import type { FC, ReactNode } from 'react'

import { ArrowUp } from 'lucide-react'
import { useScrollTo } from '@/components/landing/smooth-scroll'
import SocialLinks from '@/components/landing/social-links'
import Sparkle from '@/components/landing/decor/sparkle'

const SiteFooter: FC = (): ReactNode => {
    const scrollTo = useScrollTo()

    return (
        <footer className='relative bg-night text-mist/70'>
            <div className='mx-auto flex max-w-7xl flex-col items-center gap-6 border-t border-white/10 px-5 py-10 text-center lg:flex-row lg:justify-between lg:px-12 lg:text-left'>
                <div className='flex flex-col items-center gap-2 lg:items-start'>
                    <p className='flex items-center gap-2.5 font-heading text-lg tracking-[0.24em] text-mist'>
                        <Sparkle className='size-3.5 text-gold' />
                        AMAMA NIA
                    </p>
                    <p className='font-mono text-[10px] tracking-[0.32em]'>OBSERVATION LOG ✦ ONGOING</p>
                </div>

                <SocialLinks dark className='[&_a]:size-10' />

                <div className='flex flex-col items-center gap-3 lg:items-end'>
                    <a
                        href='#top'
                        onClick={event => {
                            event.preventDefault()
                            scrollTo('top')
                        }}
                        className='inline-flex items-center gap-2 rounded-full px-4 py-2 font-mono text-[10px] tracking-[0.3em] ring-1 ring-white/20 transition-colors duration-500 hover:bg-white/10 hover:text-mist focus-visible:outline-2 focus-visible:outline-gold'
                    >
                        <ArrowUp className='size-3.5' />
                        BACK TO TOP
                    </a>
                    <p className='text-xs tracking-[0.12em]'>© 2026 AMAMA NIA</p>
                </div>
            </div>
        </footer>
    )
}

export default SiteFooter
